document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-paginate").forEach((container) => {
    const itemsPerPage = parseInt(container.dataset.itemsPerPage) || 9;
    const itemsWrapper = container.querySelector(".paginate-items");
    if (!itemsWrapper) return;

    const items = Array.from(itemsWrapper.children);
    const totalItems = items.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // --- Create slider wrapper ---
    const slider = document.createElement("div");
    slider.classList.add("paginator-slider");

    // --- Create pages ---
    for (let i = 0; i < totalPages; i++) {
      const page = document.createElement("div");
      page.classList.add("paginator-page");

      // Create a Bootstrap row inside each page
      const row = document.createElement("div");
      row.classList.add("row");

      items
        .slice(i * itemsPerPage, (i + 1) * itemsPerPage)
        .forEach((item) => row.appendChild(item));

      page.appendChild(row);
      slider.appendChild(page);
    }

    itemsWrapper.innerHTML = ""; // Clear original
    itemsWrapper.appendChild(slider);

    // --- Navigation ---
    const pagination = document.createElement("div");
    pagination.classList.add("pagination-nav");

    const prevBtn = document.createElement("button");
    prevBtn.className = "nav-circle prev";
    prevBtn.innerHTML = '<i class="fa-light fa-chevron-left"></i>';

    const nextBtn = document.createElement("button");
    nextBtn.className = "nav-circle next";
    nextBtn.innerHTML = '<i class="fa-light fa-chevron-right"></i>';

    const pageInfo = document.createElement("div");
    pageInfo.classList.add("page-info");
    pagination.append(prevBtn, pageInfo, nextBtn);

    container.appendChild(pagination);

    // --- Slider logic ---
    let currentPage = 0;

    // compute percent-per-page once we know totalPages
    const percentPerPage = 100 / totalPages;

    const updateSlider = () => {
      // translate by one slice (not by full 100%)
      slider.style.transform = `translateX(-${currentPage * percentPerPage}%)`;
      pageInfo.textContent = `${currentPage + 1} / ${totalPages}`;
      prevBtn.disabled = currentPage === 0;
      nextBtn.disabled = currentPage === totalPages - 1;
    };

    prevBtn.addEventListener("click", () => {
      if (currentPage > 0) {
        currentPage--;
        updateSlider();
      }
    });

    nextBtn.addEventListener("click", () => {
      if (currentPage < totalPages - 1) {
        currentPage++;
        updateSlider();
      }
    });

    // --- Initial layout fixes ---
    requestAnimationFrame(() => {
      // total width of slider is number-of-pages * 100%
      slider.style.width = `${totalPages * 100}%`;

      // each page is one "slice" of the slider
      slider.querySelectorAll(".paginator-page").forEach((page) => {
        page.style.width = `${100 / totalPages}%`; // keep your existing behavior
      });

      // apply initial position
      updateSlider();
    });
  });
});
